import axiosPost from "./axiosPost";

export const SFServicioGet = async (servicioCod, credentials) => {
    const body = {
        service: "SFServicioGet",
        params: {
            servicioHooliCod: servicioCod,
        },
    };

    const response = await axiosPost(body, credentials);
    
    if (response?.result && Array.isArray(response.result)) {
        const uniqueServices = [];
        const seen = new Set();
        for (const item of response.result) {
            if (!seen.has(item.servicioCod)) {
                seen.add(item.servicioCod);
                uniqueServices.push(item);
            }
        }
        response.result = uniqueServices;
    }

    return response;
};
